/**
 * Customized to add Skeleton loading state.
 */

import { FeaturedProduct } from '@/components/content/FeaturedProduct';
import { FeaturedProductSkeleton } from '@/components/content/FeaturedProduct/parts/FeaturedProductSkeleton';
import { useFeaturedProductRecommendation } from '@/data/Content/FeaturedProductRecommendation';
import { WidgetComponentProps, WidgetProperties } from '@/data/types/Slot';
import { FC } from 'react';

const emptyProperties = {} as WidgetProperties;

export const FeaturedProductRecommendation: FC<WidgetComponentProps> = ({
	id: _id,
	properties = emptyProperties,
	sx,
}) => {
	const { emsName = '' } = properties;
	const { partNumber, clickAction, loading } = useFeaturedProductRecommendation(emsName);

	if (loading) {
		return <FeaturedProductSkeleton sx={sx} />;
	}

	return <FeaturedProduct id={partNumber} clickAction={clickAction} sx={sx} />;
};
